module.exports = __webpack_public_path__ + "static/media/riviera-desktop-popup@2x.115c981b.webp";